
// SFX file paths (organized by category, static require only)
const SFX_FILES = {
  // Missed shots
  laserMiss: {
    ogg: require('../Assets/Audio/SFX/Missed-shots/ph-laser-miss.ogg'),
    mp3: require('../Assets/Audio/SFX/Missed-shots/ph-laser-miss.mp3'),
  },
  // Vibe prawn shot
  shrimpShotHeartbroken: {
    ogg: require('../Assets/Audio/SFX/Shrimp-shots/ph-shrimp-shot-heartbroken.ogg'),
    mp3: require('../Assets/Audio/SFX/Shrimp-shots/ph-shrimp-shot-heartbroken.mp3'),
  },
  // Kill prawn shot
  shrimpShotShort: {
    ogg: require('../Assets/Audio/SFX/Shrimp-shots/ph-shrimp-shot-short.ogg'),
    mp3: require('../Assets/Audio/SFX/Shrimp-shots/ph-shrimp-shot-short.mp3'),
  },
  // Double kill SFX
  doubleKill: {
    ogg: require('../Assets/Audio/SFX/Miscellaneous/ph-double-kill.ogg'),
    mp3: require('../Assets/Audio/SFX/Miscellaneous/ph-double-kill.mp3'),
  },
  // Invasive shots (array, extended for new SFX)
  invasiveShots: [
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-1.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-1.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-2.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-2.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-3.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-3.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-4.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-4.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-5.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-5.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-6.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-6.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-7.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-7.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-8.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-8.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-9.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-9.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-10.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-10.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-11.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-11.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-12.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-12.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-13.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-13.mp3') },
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-14.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-14.mp3') },
    // New SFX for mapping
    { ogg: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-19.ogg'), mp3: require('../Assets/Audio/SFX/Invasive-shots/ph-invasive-shot-19.mp3') },
  ],
  // New plastic shots for mapping
  plasticShot3: {
    ogg: require('../Assets/Audio/SFX/Plastic-Shots/ph-plastic-shot-3.ogg'),
    mp3: require('../Assets/Audio/SFX/Plastic-Shots/ph-plastic-shot-3.mp3'),
  },
  plasticShot4: {
    ogg: require('../Assets/Audio/SFX/Plastic-Shots/ph-plastic-shot-4.ogg'),
    mp3: require('../Assets/Audio/SFX/Plastic-Shots/ph-plastic-shot-4.mp3'),
  },
  // Plastic shots
  plasticShot1: {
    ogg: require('../Assets/Audio/SFX/Plastic-Shots/ph-plastic-shot-1.ogg'),
    mp3: require('../Assets/Audio/SFX/Plastic-Shots/ph-plastic-shot-1.mp3'),
  }, // waterbottle
  plasticShot2: {
    ogg: require('../Assets/Audio/SFX/Plastic-Shots/ph-plastic-shot-2.ogg'),
    mp3: require('../Assets/Audio/SFX/Plastic-Shots/ph-plastic-shot-2.mp3'),
  }, // sixpackring
  // Miscellaneous
  click: {
    ogg: require('../Assets/Audio/SFX/Miscellaneous/ph-click.ogg'),
    mp3: require('../Assets/Audio/SFX/Miscellaneous/ph-click.mp3'),
  },
  bookShot: {
    ogg: require('../Assets/Audio/SFX/Miscellaneous/ph-book-shot.ogg'),
    mp3: require('../Assets/Audio/SFX/Miscellaneous/ph-book-shot.mp3'),
  },
  celebration: {
    ogg: require('../Assets/Audio/SFX/Miscellaneous/ph-celebration.ogg'),
    mp3: require('../Assets/Audio/SFX/Miscellaneous/ph-celebration.mp3'),
  },

};

// Per-SFX max volume (0.0 to 1.0)
const SFX_MAX_VOLUMES = {
  laserMiss: 0.65,
  shrimpShotHeartbroken: 2.01,
  shrimpShotShort: 0.8,
  plasticShot1: 0.67,
  plasticShot2: 0.8,
  plasticShot3: 0.65,
  plasticShot4: 0.8,
  click: 0.42,
  bookShot: 2.3,
  celebration: 2.4,
  doubleKill: 1.0,
  // Invasive shots: all same
  invasiveShots: 0.8,
  // Special volume for ph-invasive-shot-8 (invasiveShots_7)
  invasiveShots_7: 2.0,
};



class SoundFXManager {
  constructor(audioContext, getVolume) {
    this.audioContext = audioContext;
    this.getVolume = getVolume; // function returning current master volume (0-100)
    this.buffers = {};
    this.isMuted = false;
    this._loaded = {};
    // Don't preload all by default
  }

  // Preload a single SFX (ogg first, fallback to mp3)
  async _loadBuffer(name, srcObj) {
    let src = srcObj.ogg;
    let triedMp3 = false;
    try {
      let response = await fetch(src);
      if (!response.ok) throw new Error('OGG not found');
      let arrayBuffer = await response.arrayBuffer();
      let buffer = await this.audioContext.decodeAudioData(arrayBuffer);
      this.buffers[name] = buffer;
      this._loaded[name] = true;
    } catch (e) {
      // Try mp3 fallback
      if (!triedMp3 && srcObj.mp3) {
        triedMp3 = true;
        try {
          let response = await fetch(srcObj.mp3);
          if (!response.ok) throw new Error('MP3 not found');
          let arrayBuffer = await response.arrayBuffer();
          let buffer = await this.audioContext.decodeAudioData(arrayBuffer);
          this.buffers[name] = buffer;
          this._loaded[name] = true;
          return;
        } catch (e2) {
          // eslint-disable-next-line
          // LATER: handle error in production (failed to load SFX)
        }
      }
      // eslint-disable-next-line
  // LATER: handle error in production (failed to load SFX)
      this._loaded[name] = false;
    }
  }

  // Preload a set of SFX by keys (array of string keys or {key, index} for invasiveShots)
  async preload(keys) {
    for (const key of keys) {
      if (typeof key === 'string') {
        if (!this._loaded[key]) {
          await this._loadBuffer(key, SFX_FILES[key]);
        }
      } else if (typeof key === 'object' && key.key === 'invasiveShots') {
        // Preload all invasive shots or a specific index
        if (key.index !== undefined) {
          const bufKey = `invasiveShots_${key.index}`;
          if (!this._loaded[bufKey]) {
            await this._loadBuffer(bufKey, SFX_FILES.invasiveShots[key.index]);
          }
        } else {
          for (let i = 0; i < SFX_FILES.invasiveShots.length; ++i) {
            const bufKey = `invasiveShots_${i}`;
            if (!this._loaded[bufKey]) {
              await this._loadBuffer(bufKey, SFX_FILES.invasiveShots[i]);
            }
          }
        }
      }
    }
  }


  isLoaded(name) {
    return !!this._loaded[name];
  }


  setMuted(muted) {
    this.isMuted = muted;
  }


  playSoundFx(name, opts = {}) {
    if (this.isMuted) return;
    let buffer, maxVol;
    if (name.startsWith('invasiveShots')) {
      buffer = this.buffers[name];
      maxVol = SFX_MAX_VOLUMES[name] ?? SFX_MAX_VOLUMES.invasiveShots;
    } else {
      buffer = this.buffers[name];
      maxVol = SFX_MAX_VOLUMES[name] ?? 1.0;
    }
    if (!buffer) return;
    const source = this.audioContext.createBufferSource();
    source.buffer = buffer;
    const gain = this.audioContext.createGain();
    // Use explicit volume override if provided, else use context
    let masterVol;
    if (opts && typeof opts.volume === 'number') {
      masterVol = opts.volume;
    } else {
      masterVol = typeof this.getVolume === 'function' ? this.getVolume() : 0;
    }
    gain.gain.value = ((masterVol || 0) / 100) * maxVol;
    source.connect(gain).connect(this.audioContext.destination);
    source.start(0);
    source.onended = () => {
      source.disconnect();
      gain.disconnect();
    };
  }

  // Play a random invasive shot
  playRandomInvasiveShot() {
    const n = SFX_FILES.invasiveShots.length;
    const idx = Math.floor(Math.random() * n);
    const bufKey = `invasiveShots_${idx}`;
    if (this.isLoaded(bufKey)) {
      this.playSoundFx(bufKey);
    }
  }

  // Expose SFX file keys for phased loading
  static getIntroSfxKeys() {
    // Intro = Vibe SFX (since they're the same files, preload them early)
    // plasticShot4 used for both wiseprawn (easter egg) and labsy sprite
    return ['laserMiss', 'shrimpShotHeartbroken', 'shrimpShotShort', 'click', 'bookShot', 'plasticShot1', 'plasticShot4'];
  }
  static getKillSfxKeys() {
    // All invasive shots, plastic shots, celebration (remove SFX preloaded in intro)
    const keys = [
      { key: 'invasiveShots' },
      //'plasticShot1', // Already preloaded in intro
      'plasticShot2',
      'plasticShot3',
      //'plasticShot4', // Already preloaded in intro
      //'shrimpShotShort', // Already preloaded in intro
      'celebration',
      'doubleKill',
    ];
    return keys;
  }

  // For special-case invasive (sixpackring, waterbottle)
  playPlasticShot(which) {
    if (which === 'sixpackring') {
      if (this.isLoaded('plasticShot2')) this.playSoundFx('plasticShot2');
    } else if (which === 'waterbottle') {
      if (this.isLoaded('plasticShot1')) this.playSoundFx('plasticShot1');
    }
  }
}

export default SoundFXManager;
